var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_sigle"},[_c('div',{staticClass:"tip"},[_c('img',{staticClass:"imgtip",attrs:{"src":_vm.url,"alt":"404"}}),_c('div',[_vm._v("111抱歉！您访问的页面不存在")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }